import auth from '@/router/auth'
import CategoryCourseIndex from '@/components/category-courses/Index'
import CategoryCourseCreate from '@/components/category-courses/Create'
import CategoryCourseUpdate from '@/components/category-courses/Update'
import CategoryCourseShow from '@/components/category-courses/Show'

export default [
  {
    path: '/category-courses',
    name: 'category-courses-index',
    component: CategoryCourseIndex,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/category-courses/create',
    name: 'category-courses-create',
    component: CategoryCourseCreate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/category-courses/update/:id',
    name: 'category-courses-update',
    component: CategoryCourseUpdate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/category-courses/show/:id',
    name: 'category-courses-show',
    component: CategoryCourseShow,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/category-courses/router.js